define('modules/common/controller/ParentFascicolo',[], function() {
    var Controller = function(
        $scope,
        $stateParams,
        DeetagliFascicolo,
        LoadingHandler) {

        $scope.hrefFascicologlobal=$stateParams.hrefFascicolo.split('___').join('/');
  
    };

    return [
        "$scope",
        "$stateParams",
        "DettagliFascicolo",
        "LoadingHandler",
        Controller
    ];
});
